"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@apollo/client/core");
const graphql_ws_1 = require("graphql-ws");
const graphql_1 = require("graphql");
class WebSocketLink extends core_1.ApolloLink {
    constructor(options) {
        super();
        this.client = (0, graphql_ws_1.createClient)(options);
    }
    request(operation) {
        return new core_1.Observable(sink => {
            return this.client.subscribe({ ...operation, query: (0, graphql_1.print)(operation.query) }, {
                next: sink.next.bind(sink),
                complete: sink.complete.bind(sink),
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                error: (err) => {
                    if (err instanceof Error) {
                        return sink.error(err);
                    }
                    // Handle WebSocket closure in React Native
                    if (typeof err === 'object' && 'code' in err && 'reason' in err) {
                        return sink.error(new Error(`Socket closed with event ${err.code} ${err.reason || ''}`));
                    }
                    return sink.error(new Error(err.map(({ message }) => message).join(', ')));
                },
            });
        });
    }
}
exports.default = WebSocketLink;
//# sourceMappingURL=WebSocketLink.js.map